import React, { useContext } from 'react';
import { AccessibilityVariantsFragment } from 'app/graphql/__generated__/types/contento';
import {
    StyledTopBar,
    StyledTopBarContainer,
    TopBarMain,
    TopBarVisuallyLeft,
    TopBarVisuallyRight,
} from './TopBar.styles';
import ProgramInfo from './components/ProgramInfo';
import BackButton from './components/BackButton';
import EpisodePickerButton from '../EpisodePickerButton/EpisodePickerButton';
import { VideoPlayerContext } from '../../VideoPlayerContext';

export type TopBarProps = {
    title?: string;
    episodeTitle?: string;
    noGradient?: boolean;
    url?: string;
    videos?: Array<AccessibilityVariantsFragment>;
    selectedVideoId?: string;
    parentUrl?: string;
    showEpisodePickerButton?: boolean;
    playedPercentage?: number;
};

const TopBar: React.FC<TopBarProps> = ({
    title,
    episodeTitle,
    noGradient = false,
    url,
    videos,
    selectedVideoId,
    parentUrl,
    showEpisodePickerButton,
    playedPercentage,
}) => {
    const { displayEpisodePicker } = useContext(VideoPlayerContext);

    return (
        <StyledTopBarContainer noGradient={noGradient}>
            <StyledTopBar justifyEnd={displayEpisodePicker}>
                {displayEpisodePicker ? (
                    <>
                        <TopBarVisuallyLeft />
                        <TopBarMain />
                    </>
                ) : (
                    <>
                        <TopBarVisuallyLeft>
                            <BackButton />
                        </TopBarVisuallyLeft>
                        <TopBarMain>
                            <ProgramInfo
                                title={title}
                                episodeTitle={episodeTitle}
                                url={url}
                                videos={videos}
                                selectedVideoId={selectedVideoId}
                                parentUrl={parentUrl}
                            />
                        </TopBarMain>
                    </>
                )}
                {showEpisodePickerButton && parentUrl !== '/susannes-skafferi' && (
                    <TopBarVisuallyRight>
                        <EpisodePickerButton playedPercentage={playedPercentage} />
                    </TopBarVisuallyRight>
                )}
            </StyledTopBar>
        </StyledTopBarContainer>
    );
};

export default TopBar;
